export const styles = [
  { id: 'default-apa', name: 'APA 6' },
  { id: 'apa-7th-edition', name: 'APA 7' },
  { id: 'default-chicago', name: 'Chicago' },
  { id: 'default-harvard', name: 'Harvard' },
  { id: 'harvard-australia', name: 'Harvard (Australia)' },
  { id: 'modern-language-association-8th-edition', name: 'MLA 8' },
  { id: 'default-mla', name: 'MLA 9' }
]



// WEBPACK FOOTER //
// ./src/utils/styles.js